import { createFileRoute } from "@tanstack/react-router"

import { FlagCompaniesTab } from "~/features/feature-flags/pages"

export const Route = createFileRoute("/_auth/internal/feature-flags/$flagKey/_layout/")({
  component: FlagCompaniesTab,
})
